<template>
  <section class="sonar-lab-session__container">
    <div class="sonar-lab-session__wrapper">
      <SonarCardCurrentSession
        ref="currentLabSession"
        :currentLab="currentLab"
        :isLoading="isLoading"
        :loadingLabel="loadingLabel"
        @close-modal="toggleLab"
        @lab-started="handleLabStarted"
      />
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import CONSTANTS from '@/constants'
import SonarCardCurrentSession from './SonarCardCurrentSession.vue'
import { sonarCommons } from '../../../helpers/mixins'

export default {
  name: 'SonarLabSession',
  components: {
    SonarCardCurrentSession,
  },
  mixins: [sonarCommons],
  data() {
    return {
      isLoading: false,
      isStoppingLab: false,
      loadingLabel: '',
    }
  },
  computed: {
    ...mapState({
      currentLab: state => state.labs.currentLab,
      currentLabSession: state => state.labs.currentLabSession,
    }),
    ...mapGetters({
      currentQuestion: 'sonar/currentQuestion',
      assessmentAttempt: 'sonar/assessmentAttempt',
      isSwitchingLabs: 'sonar/isSwitchingLabs',
    }),
    isLabRunning() {
      return (
        this.currentLabSession?.status === CONSTANTS.LABS.SESSION_STATUS.STARTED
      )
    },
  },
  async created() {
    if (this.isSwitchingLabs) {
      await this.switchLabs()
    } else {
      await this.fetchContent()
      this.isLoading = false
    }
  },
  methods: {
    ...mapActions('labs', ['getRunningLab']),
    async toggleLab() {
      if (this.isLabRunning) {
        await this.updateSessionStatus(CONSTANTS.LABS.SESSION_STATUS.TERMINATED)
      }
    },
    async fetchContent() {
      this.isLoading = true
      await this.getRunningLab()
      const labId = this.currentQuestion?.labData.content_id
      await this.$store.dispatch('labs/getLabById', {
        id: labId,
        parentId: this.assessmentAttempt?.id,
        parentType: CONSTANTS.PARENT_CONTENT_TYPES_KEYS.ASSESSMENT,
      })
    },
    handleLabStarted(status) {
      this.labStarted = status
    },
    async switchLabs() {
      this.isLoading = true
      this.loadingLabel = 'Switching labs'
      this.$store.dispatch('sonar/setCanAnswerLabQuestions', false)
      const regionSelected = localStorage.getItem(`pta-lab-region`) || 'US-East'
      const keyboardSelected =
        localStorage.getItem(`pta-lab-keyboard`) || 'en-us-qwerty'
      try {
        await this.toggleLab()
        await this.fetchContent()
        if (
          this.currentLabSession?.lab?.id !== this.currentLab?.id ||
          (this.currentLabSession?.status !==
            CONSTANTS.LABS.SESSION_STATUS.STARTED &&
            this.currentLabSession?.lab?.id === this.currentLab?.id)
        ) {
          await this.$store.dispatch('labs/createLabSession', {
            id: this.currentLab.id,
            region: regionSelected,
            keyboard_layout: keyboardSelected,
            parentId: this.assessmentAttempt?.id,
            parentType: CONSTANTS.PARENT_CONTENT_TYPES_KEYS.ASSESSMENT,
          })
        }
      } catch (e) {
        this.isLoading = false
        this.loadingLabel = ''
        this.$store.dispatch('sonar/setSwitchingLabs', false)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.sonar-lab-session {
  width: 100%;
  height: 100%;
  min-height: 280px;
  border-top: 1px solid var(--tundora-gray);

  &__wrapper {
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
  }
  &__container {
    width: 100%;
    height: 100%;
  }
}
</style>
